// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALTkG4CdTFPG1iE_VnNttYLA6RxBXXE8g",
  authDomain: "hideep-84a7e.firebaseapp.com",
  projectId: "hideep-84a7e",
  storageBucket: "hideep-84a7e.appspot.com",
  messagingSenderId: "113610310187",
  appId: "1:113610310187:web:2c93339b7e86fd6a36e06e",
  measurementId: "G-F5ED8G0R14",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
export { app, db, auth };

const analytics = getAnalytics(app);
